// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * NextWork API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Track } from './track';
import {
    TrackFromJSON,
    TrackFromJSONTyped,
    TrackToJSON,
    TrackToJSONTyped,
} from './track';

/**
 * 
 * @export
 * @interface ProjectMetadata
 */
export interface ProjectMetadata {
    /**
     * 
     * @type {string}
     * @memberof ProjectMetadata
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectMetadata
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectMetadata
     */
    icon?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectMetadata
     */
    difficulty?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectMetadata
     */
    time?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectMetadata
     */
    cost?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProjectMetadata
     */
    needs?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProjectMetadata
     */
    lastModified?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProjectMetadata
     */
    concepts?: Array<string>;
    /**
     * 
     * @type {Array<Track>}
     * @memberof ProjectMetadata
     */
    tracks?: Array<Track>;
    /**
     * 
     * @type {string}
     * @memberof ProjectMetadata
     */
    visibility?: ProjectMetadataVisibilityEnum;
    /**
     * 
     * @type {string}
     * @memberof ProjectMetadata
     */
    plan?: ProjectMetadataPlanEnum;
    /**
     * 
     * @type {string}
     * @memberof ProjectMetadata
     */
    sharetemplate?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectMetadata
     */
    linkedintemplate?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectMetadata
     */
    twittertemplate?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectMetadata
     */
    instagramtemplate?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectMetadata
     */
    facebooktemplate?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectMetadata
     */
    shortformtemplate?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectMetadata
     */
    category?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectMetadata
     */
    order?: string;
    /**
     * The number of which this project is in the series it is apart of. I.e Part 1.
     * @type {number}
     * @memberof ProjectMetadata
     */
    part?: number;
}


/**
 * @export
 */
export const ProjectMetadataVisibilityEnum = {
    PRIVATE: 'private',
    PUBLIC: 'public'
} as const;
export type ProjectMetadataVisibilityEnum = typeof ProjectMetadataVisibilityEnum[keyof typeof ProjectMetadataVisibilityEnum];

/**
 * @export
 */
export const ProjectMetadataPlanEnum = {
    FREE: 'free',
    PRO: 'pro'
} as const;
export type ProjectMetadataPlanEnum = typeof ProjectMetadataPlanEnum[keyof typeof ProjectMetadataPlanEnum];


/**
 * Check if a given object implements the ProjectMetadata interface.
 */
export function instanceOfProjectMetadata(value: object): value is ProjectMetadata {
    return true;
}

export function ProjectMetadataFromJSON(json: any): ProjectMetadata {
    return ProjectMetadataFromJSONTyped(json, false);
}

export function ProjectMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectMetadata {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'icon': json['icon'] == null ? undefined : json['icon'],
        'difficulty': json['difficulty'] == null ? undefined : json['difficulty'],
        'time': json['time'] == null ? undefined : json['time'],
        'cost': json['cost'] == null ? undefined : json['cost'],
        'needs': json['needs'] == null ? undefined : json['needs'],
        'lastModified': json['lastModified'] == null ? undefined : json['lastModified'],
        'concepts': json['concepts'] == null ? undefined : json['concepts'],
        'tracks': json['tracks'] == null ? undefined : ((json['tracks'] as Array<any>).map(TrackFromJSON)),
        'visibility': json['visibility'] == null ? undefined : json['visibility'],
        'plan': json['plan'] == null ? undefined : json['plan'],
        'sharetemplate': json['sharetemplate'] == null ? undefined : json['sharetemplate'],
        'linkedintemplate': json['linkedintemplate'] == null ? undefined : json['linkedintemplate'],
        'twittertemplate': json['twittertemplate'] == null ? undefined : json['twittertemplate'],
        'instagramtemplate': json['instagramtemplate'] == null ? undefined : json['instagramtemplate'],
        'facebooktemplate': json['facebooktemplate'] == null ? undefined : json['facebooktemplate'],
        'shortformtemplate': json['shortformtemplate'] == null ? undefined : json['shortformtemplate'],
        'category': json['category'] == null ? undefined : json['category'],
        'order': json['order'] == null ? undefined : json['order'],
        'part': json['part'] == null ? undefined : json['part'],
    };
}

export function ProjectMetadataToJSON(json: any): ProjectMetadata {
    return ProjectMetadataToJSONTyped(json, false);
}

export function ProjectMetadataToJSONTyped(value?: ProjectMetadata | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'description': value['description'],
        'icon': value['icon'],
        'difficulty': value['difficulty'],
        'time': value['time'],
        'cost': value['cost'],
        'needs': value['needs'],
        'lastModified': value['lastModified'],
        'concepts': value['concepts'],
        'tracks': value['tracks'] == null ? undefined : ((value['tracks'] as Array<any>).map(TrackToJSON)),
        'visibility': value['visibility'],
        'plan': value['plan'],
        'sharetemplate': value['sharetemplate'],
        'linkedintemplate': value['linkedintemplate'],
        'twittertemplate': value['twittertemplate'],
        'instagramtemplate': value['instagramtemplate'],
        'facebooktemplate': value['facebooktemplate'],
        'shortformtemplate': value['shortformtemplate'],
        'category': value['category'],
        'order': value['order'],
        'part': value['part'],
    };
}

